import { useCallback, useState } from 'react';
import { VideoSize } from 'types';

import { VideoPlayer, VideoPlayerOptions } from 'components/VideoPlayer';
import { VideoThumbnail } from 'components/VideoThumbnail';

type Props = {
  videoUrl: string;
  thumbnailUrl?: string;
  size: VideoSize;
  largePlayButton?: boolean;
  thumbnailQaId?: string;
  playerQaId?: string;
  playerOptions?: VideoPlayerOptions;
};

export function VideoThumbnailPlayer({
  videoUrl,
  thumbnailUrl,
  size,
  largePlayButton,
  thumbnailQaId,
  playerQaId,
  playerOptions,
}: Props) {
  const [state, setState] = useState<'thumbnail' | 'player'>('thumbnail');

  const showPlayer = useCallback(() => {
    setState('player');
  }, []);

  if (state === 'thumbnail') {
    return (
      <VideoThumbnail
        src={
          thumbnailUrl
            ? { type: 'image-url', imageUrl: thumbnailUrl }
            : { type: 'video-thumbnail', videoUrl }
        }
        size={size}
        playButton={largePlayButton ? 'large' : 'small'}
        onClick={showPlayer}
        qaId={thumbnailQaId}
      />
    );
  }

  return (
    <VideoPlayer
      url={videoUrl}
      size={size}
      options={playerOptions}
      qaId={playerQaId}
      autoPlay
    />
  );
}
